import React, { useState,useEffect } from 'react'
import LoadingProtal from '../components/common/LoadingProtal';
import PortalDashboardComponent from '../components/PortalDashboardComponent';

function RootPage() {

    const [ready,setReady] = useState(false);
    useEffect(()=>{
        let portalId = localStorage.getItem("portalId");
        if(portalId == null){
            setReady(true);
        } 
    },[])

    return (
        
                ready ?
                    <LoadingProtal/>
                :
                    <PortalDashboardComponent/>
                
        
    )
}

export default RootPage